import React from 'react';
import { dashFooterArea } from '../styles/MasterCSSClass';

const EventOrgFooter = () => {
  return (
    <footer className={dashFooterArea}>
      <div className="absolute right-6 text-xs text-slate-500 font-normal">
      ShowIsHere © 2026 — All rights reserved
    </div>
    </footer>
  );
};

export default EventOrgFooter;